import { toast as internalToaster } from "svelte-sonner";
import CheckCircle from "$assets/icons/check-circle.svelte";
import InfoCircle from "$assets/icons/info-circle.svelte";
import OctagonXMark from "$assets/icons/octagon-xmark.svelte";

export const toaster = {
  success: (title: string, description: string) => {
    internalToaster.success(title, {
      description: description,
      classes: {
        toast: "!text-success",
        title: "ml-1 !text-black dark:!text-white",
        description: "ml-1 !text-gray-600 dark:!text-gray-300 !font-normal",
      },
      icon: CheckCircle,
      onDismiss: (t) => {},
    });
    console.log("Success Toast", { title: title, description: description });
  },
  info: (title: string, description: string) => {
    internalToaster.info(title, {
      description: description,
      classes: {
        toast: "!text-error",
        title: "ml-1 !text-black dark:!text-white",
        description: "ml-1 !text-gray-600 dark:!text-gray-300 !font-normal",
      },
      icon: InfoCircle,
      onDismiss: (t) => {},
    });
    console.log("Error Toast", { title: title, description: description });
  },
  error: (title: string, description: string) => {
    internalToaster.error(title, {
      description: description,
      classes: {
        toast: "!text-error",
        title: "ml-1 !text-black dark:!text-white",
        description: "ml-1 !text-gray-600 dark:!text-gray-300 !font-normal",
      },
      icon: OctagonXMark,
      onDismiss: (t) => {},
    });
    console.log("Error Toast", { title: title, description: description });
  },
};
